<template>
  <div class="container">
    <div id="page-div" class="container interline" ref="document">
      <div id="page1-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12 text-center">
            <span class="ft15Black"> <br />GPI AUTO COMERCIAL<br /> </span>
          </div>
          <div class="col-12 text-center">
            <span class="ft7Gray">
              <br />Av. De las Rosas 2991, Colonia. Chapalita, C.P. 44510,
              Guadalajara, Jalisco.<br />
            </span>
          </div>
          <div class="col-12">
            <span v-if="data.tipoClasico" class="ft9">
              <span class="ft9Black">
                CONTRATO DE APERTURA DE CRÉDITO SIMPLE CON GARANTÍA PRENDARIA
              </span>
              SIN TRANSMISIÓN DE LA POSESIÓN, EN ADELANTE, EL “CONTRATO”, QUE
              CELEBRAN POR UNA PARTE, BAJO EL CARÁCTER DE ACREDITANTE
              <span class="ft9Black">
                GPI AUTO COMERCIAL SAPI DE C.V.
              </span>
              REPRESENTADO POR JESÚS FERNÁNDEZ MORÁN, EN ADELANTE, EL
              “ACREDITANTE”, POR LA OTRA, BAJO EL CARÁCTER DE ACREDITADO LA
              PERSONA FISICA
              <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                {{ data.nombre_cliente }},
              </span>
              EN ADELANTE EL “ACREDITADO”, DE CONFORMIDAD CON LOS ANTECEDENTES,
              DECLARACIONES, DEFINICIONES Y CLÁUSULAS SIGUIENTES:.
              <br /><br />
            </span>
            <span v-if="data.tipoAval" class="ft9">
              <span class="ft9Black">
                CONTRATO DE APERTURA DE CRÉDITO SIMPLE CON GARANTÍA PRENDARIA
              </span>
              SIN TRANSMISIÓN DE LA POSESIÓN, EN ADELANTE, EL “CONTRATO”, QUE
              CELEBRAN POR UNA PARTE, BAJO EL CARÁCTER DE ACREDITANTE
              <span class="ft9Black">
                GPI AUTO COMERCIAL SAPI DE C.V.
              </span>
              REPRESENTADO POR JESÚS FERNÁNDEZ MORÁN, EN ADELANTE, EL
              “ACREDITANTE”, POR LA OTRA, BAJO EL CARÁCTER DE ACREDITADO LA
              PERSONA FISICA
              <span class="ft9Black">
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.nombre_cliente }},
                </span>
              </span>
              EN ADELANTE EL "ACREDITADO", ASÍ COMO, BAJO EL CARÁCTER DE AVAL LA
              PERSONA FISICA
              <span class="ft9Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.nombre_aval }},
              </span>
              EN ADELANTE, EL “AVAL Y OBLIGADO SOLIDARIO", DE CONFORMIDAD CON LOS ANTECEDENTES,
              DECLARACIONES, DEFINICIONES Y CLÁUSULAS SIGUIENTES: <br /><br />
            </span>
            <span v-if="data.tipoObligado" class="ft9">
              <span class="ft9Black">
                CONTRATO DE APERTURA DE CRÉDITO SIMPLE CON GARANTÍA PRENDARIA
              </span>
              SIN TRANSMISIÓN DE LA POSESIÓN, EN ADELANTE, EL “CONTRATO”, QUE
              CELEBRAN POR UNA PARTE, BAJO EL CARÁCTER DE ACREDITANTE
              <span class="ft9Black">
                GPI AUTO COMERCIAL SAPI DE C.V.
              </span>
              REPRESENTADO POR JESÚS FERNÁNDEZ MORÁN, EN ADELANTE, EL
              “ACREDITANTE”, POR LA OTRA, BAJO EL CARÁCTER DE ACREDITADO LA
              PERSONA FISICA
              <span class="ft9Black">
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.nombre_cliente }},
                </span>
              </span>
              EN ADELANTE EL "ACREDITADO", ASÍ COMO, BAJO EL CARÁCTER DE OBLIGADO SOLIDARIO LA
              PERSONA FISICA
              <span class="ft9Black">
                <span v-bind:class="{ 'marca-obligado': data.showMarca }">
                  {{ data.nombre_obligado }},
                </span>
              </span>
              EN ADELANTE, EL “AVAL Y OBLIGADO SOLIDARIO", DE CONFORMIDAD CON LOS
              ANTECEDENTES, DECLARACIONES, DEFINICIONES Y CLÁUSULAS SIGUIENTES:
            </span>
            <span v-if="data.tipoObligadoAval" class="ft9">
              <span class="ft9Black">
                CONTRATO DE APERTURA DE CRÉDITO SIMPLE CON GARANTÍA PRENDARIA
              </span>
              SIN TRANSMISIÓN DE LA POSESIÓN, EN ADELANTE, EL “CONTRATO”, QUE
              CELEBRAN POR UNA PARTE, BAJO EL CARÁCTER DE ACREDITANTE
              <span class="ft9Black">
                GPI AUTO COMERCIAL SAPI DE C.V.
              </span>
              REPRESENTADO POR JESÚS FERNÁNDEZ MORÁN, EN ADELANTE, EL
              “ACREDITANTE”, POR LA OTRA, BAJO EL CARÁCTER DE ACREDITADO LA
              PERSONA FISICA
              <span class="ft9Black">
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.nombre_cliente }},
                </span>
              </span>
              EN ADELANTE EL "ACREDITADO", ASÍ COMO, BAJO EL CARÁCTER DE
              OBLIGADO SOLIDARIO LA PERSONA FISICA
              <span class="ft9Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.nombre_obligado }},
              </span>
              EN ADELANTE EL "AVAL Y OBLIGADO SOLIDARIO", ASÍ COMO, BAJO EL CARÁCTER DE
              AVAL LA PERSONA FISICA
              <span class="ft9Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.nombre_aval }},
              </span>
              EN ADELANTE, EL “AVAL Y OBLIGADO SOLIDARIO", DE CONFORMIDAD CON LOS ANTECEDENTES,
              DECLARACIONES, DEFINICIONES Y CLÁUSULAS SIGUIENTES: <br /><br />
            </span>
            <span class="ft9Black">
              <div class="col-12 text-center">ANTECEDENTES.<br /><br /></div>
            </span>
            <div class="text-justify">
              <span class="ft9">
                <span class="ft9Black text-center">PRIMERO.</span> El
                ACREDITADO, a través de la solicitud que formuló y firmó, en
                adelante, la “Solicitud”, requirió al ACREDITANTE el
                otorgamiento de un crédito simple con garantía prendaria sin
                transmisión de la posesión, en adelante, el “Crédito”.<br /><br />
              </span>
              <span class="ft9">
                <span class="ft9Black text-center">SEGUNDO.</span> El
                ACREDITANTE, previa revisión y análisis de la Solicitud, así
                como de la demás información y documentación que fuera
                proporcionada y presentada por el ACREDITADO, determinó que
                estos, cuentan con recursos económicos suficientes para el
                cumplimiento de todas y cada una de las obligaciones asumidas
                por la celebración del Contrato, por lo que autorizó la
                Solicitud y el otorgamiento del Crédito a favor del
                ACREDITADO.<br /><br />
              </span>
            </div>
            <span class="ft9Black">
              <div class="col-12 text-center">DECLARACIONES.<br /><br /></div>
            </span>
            <div class="text-justify">
              <span class="ft9Black text-center">
                PRIMERA.<span class="ft9"> Declara el</span> ACREDITANTE,
                <span class="ft9">que:</span> <br /><br />
              </span>
              <span class="ft9">
                a) Es una sociedad mercantil debidamente constituida y
                válidamente existente conforme a las leyes de los Estados Unidos
                Mexicanos, según consta en la Escritura Pública número 9,195, de
                fecha 23 de marzo de 2015, pasada ante la fe del Lic. Rodolfo
                Ramos Menchaca, Notario Público número 117 de Guadalajara,
                Jalisco; la cual quedó registrada bajo folio mercantil 90932*1
                en el Registro Público de la Propiedad y de Comercio de
                Guadalajara, Jalisco, obligándose bajo los términos que se
                establecen en el Contrato. <br /><br />
              </span>
              <span class="ft9">
                b) Su Representante cuenta con los poderes y facultades
                suficientes para celebrar el presente Contrato de Préstamo
                Mercantil, los que a la fecha no le han sido revocados o
                limitados, como lo acredita con la Escritura Pública número
                37,563 suscrita ante la fe del licenciado Guillermo Coronado
                Figueroa, notario público 50 de Guadalajara, Jalisco, de fecha 4
                de Noviembre del 2021.<br /><br />
              </span>
              <span class="ft9">
                c) Señala como su domicilio, para los efectos relacionados con
                el Contrato, Avenida de las Rosas 2991, colonia Chapalita,
                Guadalajara 44510, Jalisco.<br /><br />
              </span>
              <span class="ft9">
                d) Se encuentra inscrito ante la SECRETARÍA DE HACIENDA Y
                CRÉDITO PÚBLICO a través del SERVICIO DE ADMINISTRACIÓN
                TRIBUTARIA, mediante REGISTRO FEDERAL DE CONTRIBUYENTES, con RFC
                GAC150505Q30.<br /><br />
              </span>
              <span class="ft9">
                e) Es su intención otorgar el Crédito al ACREDITADO, conforme a
                las estipulaciones del Contrato.<br /><br />
              </span>
              <span class="ft9Black text-center">
                SEGUNDA.<span class="ft9"> Declara el</span> ACREDITADO,
                <span class="ft9">que:</span> <br /><br />
              </span>
              <span class="ft9">
                a) Es una persona física que interviene por su propio derecho en
                la celebración del Contrato, obligándose bajo los términos que
                se establecen en el mismo.
                <br /><br />
              </span>
              <span class="ft9">
                b) Señala como su domicilio, para los efectos relacionados con
                el Contrato, CALLE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.calle_cliente }}</span>
                No.
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.numero_calle_cliente }} </span>
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.numero_calle_int_cliente }}</span>
                COLONIA
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.colonia_cliente }},
                </span>
                CODIGO POSTAL
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.codigo_postal_cliente }},
                </span>
                DE LA POBLACION DE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_cliente }},
                </span>
                MUNICIPIO DE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_cliente }},
                </span>
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_cliente }}. </span><br /><br />
              </span>
              <span class="ft9">
                c) El <span class="ft9Black text-center">ACREDITANTE</span>, con
                anterioridad a la fecha de celebración del Contrato, le indicó
                las características aplicables al Crédito, los importes que
                puedan surgir con motivo de intereses, Comisiones, impuestos y/o
                cualquier otro cargo relacionado con el mismo, de conformidad
                con el Contrato, así como, el costo anual total (CAT) de
                financiamiento expresado en términos porcentuales anuales que,
                para fines informativos y de comparación, incorpora la totalidad
                de los costos y gastos inherentes al Crédito, el cual asciende
                al porcentaje indicado en la Carátula (en adelante, la
                “Información del Crédito”) e informó de todos aquellos
                documentos a firmar por el otorgamiento del Crédito.
                <br /><br />
              </span>
              <span class="ft9">
                d) Cuenta con los recursos económicos suficientes para el
                cumplimiento de todas y cada una de las obligaciones asumidas
                por la celebración del Contrato, mismos que provienen y
                provendrán de fuentes lícitas.
                <br /><br />
              </span>
              <span class="ft9">
                e) Está de acuerdo en: (i) garantizar el cumplimiento de todas y
                cada una de sus obligaciones asumidas en el Contrato con una
                prenda sin transmisión de la posesión sobre el Bien; y, (ii)
                constituirse como Depositario, en los términos y para los
                efectos que se indican en el Contrato.
                <br /><br />
              </span>
              <span class="ft9">
                f) Tiene conocimiento de que el ACREDITANTE podrá entregar al
                Registro Público Vehicular un aviso de constitución de la
                garantía prendaria y/o inscribir ante el Registro Único de
                Garantías Mobiliarias la garantía mencionada, en términos de la
                regulación aplicable.<br /><br />
              </span>
              <span class="ft9">
                g) Ha recibido del ACREDITANTE el Anexo de Comisiones y la tabla
                de amortización en donde se describen las fechas y montos que
                deberá pagar al ACREDITANTE conforme al Contrato (en adelante, la
                “Tabla de Amortización”), los cuales le fueron explicados por el
                ACREDITANTE a su entera satisfacción y que comprende
                plenamente.<br /><br />
              </span>
              <span class="ft9">
                h) El ACREDITANTE hizo de su conocimiento, que el modelo de
                Contrato y Carátula, se encuentran a su disposición en la Página
                de Internet.
                <br /><br />
              </span>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              1
            </span>
          </div>
        </footer>
      </div>
      <div id="page2-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br />
            i) La información y documentación que proporcionó y presentó al
            ACREDITANTE, así como la información que asentó en la Solicitud y el
            Formato de Características del Bien, es verdadera y correcta.
            <br /><br />
          </span>
          <span class="ft9">
            j) Es su intención que el ACREDITANTE le otorgue el Crédito,
            conforme a las estipulaciones del Contrato, mismo que garantizará
            con una prenda sin transmisión de la posesión sobre el Bien.<br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">TERCERA.</span> Declara el
            <span v-if="data.tipoAval" class="ft9">
              “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              AVAL y OBLIGADO SOLIDARIO
            </span>
            <span class="ft9" v-else>
              “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            que:<br /><br />
          </span>
          <span class="ft9">
            a) Es una persona física que interviene por su propio derecho en la
            celebración del Contrato, obligándose bajo los términos que se
            establecen en el mismo.
            <br /><br />
          </span>
          <span class="ft9">
            b) Señala como su domicilio, para los efectos relacionados con el
            Contrato.<br /><br />
          </span>
          <span class="ft9">
            c) Cuenta con los recursos económicos suficientes para el
            cumplimiento de todas y cada una de sus obligaciones que en términos
            del Contrato contrae a su cargo, mismos que provienen y provendrán
            de fuentes lícitas.
            <br /><br />
          </span>
          <span class="ft9">
            d) Formuló y firmó, junto con el ACREDITADO y, en su carácter de
            <span v-if="data.tipoAval" class="ft9"> AVAL</span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              AVAL y OBLIGADO SOLIDARIO</span>
            <span class="ft9" v-else> OBLIGADO SOLIDARIO</span>, la
            Solicitud.<br /><br />
          </span>
          <span class="ft9">
            e) El ACREDITANTE, con anterioridad a la fecha de celebración del
            Contrato, le proporcionó la Información del Crédito e informó de
            todos aquellos documentos a firmar por el otorgamiento del
            Crédito.<br /><br />
          </span>
          <span class="ft9">
            f) La información y documentación que proporcionó y presentó al
            ACREDITANTE, así como la información que asentó en la Solicitud, es
            verdadera y correcta.<br /><br />
          </span>
          <span class="ft9">
            g) Es su intención asumir, ante el ACREDITANTE, el carácter de
            <span v-if="data.tipoAval" class="ft9">
              “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else>
              “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            del ACREDITADO, para el cumplimiento de todas y cada una de las
            obligaciones asumidas por la celebración del Contrato y, que, con
            respecto al Crédito, el ACREDITADO contrae a su cargo.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">CUARTA. </span>Declaran el ACREDITANTE y el
            ACREDITADO, que: a) Se reconocen la capacidad jurídica con la que
            comparecen para celebrar el Contrato.<br /><br />
          </span>
          <span class="ft9">
            b) Para el supuesto de intervenir de manera conjunta en diversa
            estipulación del Contrato, se les denominará como las “PARTES”.<br /><br />
          </span>
          <span class="ft9">
            c) El Contrato lo celebran: (i) de mutuo acuerdo; (ii) sin que
            exista algún vicio de la voluntad; y, (iii) bajo el amparo de sus
            estipulaciones.<br /><br />
          </span>
          <span class="ft9">
            d) La Solicitud, así como la información y documentación que el
            ACREDITADO
            <span v-if="data.tipoAval" class="ft9">
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else>
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            proporcionaron y presentaron al ACREDITANTE, son integrantes para
            los efectos conducentes del Contrato.<br /><br />
          </span>
          <span class="ft9Black">
            <div class="col-12 text-center">DEFINICIONES.<br /><br /></div>
          </span>
          <div class="text-justify">
            <span class="ft9">
              Para efectos del Contrato, las PARTES asignan a los términos
              señalados a continuación, escritos con letra mayúscula inicial, el
              significado que en cada caso se les atribuye, a menos que el
              contexto en que se utilicen implique un concepto diferente y así
              se indique, independientemente de su utilización en singular o en
              plural.<br /><br /> </span><span class="ft9">
              “Anexo de Comisiones”. Significa el documento que emitirá el
              ACREDITANTE y, que contiene el concepto y monto del Cargo por
              Comisiones y Servicios que se detallaran en la Caratula del
              Contrato.<br /><br />
            </span>
            <span class="ft9">
              “Aseguradora”. Significa la compañía de seguros encargada de
              emitir la póliza respecto del Bien y, que responderá hasta donde
              expresamente señale la misma.<br /><br />
            </span>
            <span class="ft9">
              “Bien”. Significa el vehículo automotor nuevo o seminuevo de uso
              particular o comercial (con excepción al uso de transporte público
              y de seguridad pública o privada), identificado e individualizado
              en el Formato de Características del Bien, que será adquirido por
              el ACREDITADO con recursos del Crédito y el cual será otorgado en
              garantía prendaria al ACREDITANTE para garantizar el cumplimiento
              de todas y cada una de las obligaciones asumidas por el ACREDITADO
              en el Contrato.<br /><br />
            </span>
            <span class="ft9">
              “Carátula”. Significa el documento que es parte integrante del
              Contrato en el que se establece, entre otras cosas, la Información
              del Crédito y su tabla de pagos. Los importes que se asientan en
              la Carátula se expresan en pesos, moneda nacional.<br /><br />
            </span>
            <span class="ft9">
              “Cargo por Servicio de GPS: Tendrá el significado que se le
              atribuye en la Cláusula Décima Primera del
              Contrato.<br /><br />
            </span>
            <span class="ft9">
              “Carta de Instrucción de Pago a la Aseguradora”. Significa el
              documento que, según corresponda, será suscrito por el ACREDITADO,
              en virtud del cual, instruye al ACREDITANTE para que, en su nombre
              y representación, entregue a favor de la Aseguradora, la parte del
              Importe del Crédito que corresponda al pago de la prima del Seguro
              aplicable sobre el Bien, según lo establecido en la Carátula y en
              el Contrato.<br /><br />
            </span>
            <span class="ft9">
              “Carta de Instrucción de Pago a Tercero”. Significa el documento
              suscrito por el ACREDITADO, en virtud del cual instruye
              irrevocablemente al ACREDITANTE para que, en su nombre y
              representación, entregue a favor del Proveedor, la parte del
              Importe del Crédito que corresponda al pago del precio del Bien,
              en virtud de la compraventa celebrada entre el Proveedor, como
              vendedor, y el ACREDITADO, como comprador, según lo establecido en
              el Contrato.<br /><br />
            </span>
            <span class="ft9">
              “Comisiones”. Significan conjuntamente, la Comisión por Gastos de
              Administración de Saldos, la Comisión por Gastos de Cobranza y la
              Comisión por Pago Anticipado.<br /><br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              2
            </span>
          </div>
        </footer>
      </div>
      <div id="page3-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br />
            “Comisión por Apertura”. Tendrá el significado que se le atribuye en
            la Cláusula Décima Primera del Contrato.

            <br />
          </span>
          <span class="ft9">
            “Comisión por Gastos de Administración de Saldos”. Tendrá el
            significado que se le atribuye en la Cláusula
            Décima Primera del Contrato.
            <br />
          </span>
          <span class="ft9">
            “Comisión por Gastos de Cobranza”. Tendrá el significado que se le
            atribuye en la Cláusula Décima Primera del
            Contrato.
            <br />
          </span>
          <span class="ft9">
            “Comisión por Pago Anticipado”. Tendrá el significado que se le
            atribuye en la Cláusula Décima Primera del
            Contrato.<br />
          </span>
          <span class="ft9">
            “Depositario”. Tendrá el significado que se le atribuye en la Cláusula Octava del Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            “Día Hábil”. Significa cualquier día de la semana, excluyendo los
            días sábado y domingo, así como los días en que, conforme a las
            disposiciones aplicables, las instituciones de crédito deban cerrar
            sus puertas, suspender operaciones, así como la prestación de
            servicios al público.<br /><br />
          </span>
          <span class="ft9">
            “Fecha de Corte”. Significa el día del mes indicado en la Carátula,
            en que termina el periodo en el que se registran los movimientos
            efectuados.<br /><br />
          </span>
          <span class="ft9">
            “Fecha de Pago de las Parcialidades”. Significa el Día Hábil en el
            que el ACREDITADO deberá pagar al ACREDITANTE la respectiva
            Parcialidad, y que se indicará claramente en el Instrumento de Pago
            de las Parcialidades y en la Tabla de Amortización.
            <br /><br />
          </span>
          <span class="ft9">
            “Formato de Características del Bien”. Significa el documento que
            contiene las características físicas del Bien elegido por el
            ACREDITADO.
            <br /><br />
          </span>
          <span class="ft9">
            “Importe del Crédito”. Significa el monto del Crédito que se indica
            en la Carátula y que, conforme al Contrato, es otorgado al
            ACREDITADO por el ACREDITANTE. “Importe Total del Crédito”.
            Significa el monto total a pagar por el otorgamiento del Crédito,
            mismo que de manera inicial se indica en la Carátula, y que el
            ACREDITADO deberá pagar al ACREDITANTE. El Importe Total del Crédito
            resulta de sumar al Importe del Crédito: (i) los Intereses
            Ordinarios; (ii) el IVA de los Intereses Ordinarios; (iii) en su
            caso, los Intereses Moratorios que se llegaren a generar, en
            términos del Contrato; (iv) en su caso, el IVA de los Intereses
            Moratorios; (v) cualquier Comisión, cargo o accesorio que, en su
            caso, el ACREDITANTE tenga derecho a recibir del ACREDITADO, en
            términos del Contrato o de la legislación aplicable junto con los
            respectivos impuestos; y/o, (vi) los gastos y costas en los que
            incurra el ACREDITANTE derivados de cualquier procedimiento
            extrajudicial o judicial que derive de un incumplimiento del
            ACREDITADO al Contrato, del Pagaré o la ejecución de la Prenda; lo
            anterior, en el entendido que en caso que se genere algún otro
            accesorio, gasto o costa que deba ser pagado al ACREDITANTE conforme
            al Contrato, el Importe Total del Crédito se incrementará para
            adicionarle las cantidades correspondientes.<br /><br />
          </span>
          <span class="ft9">
            “Intereses Moratorios”. Tendrá el significado que se le atribuye en
            el segundo párrafo de la Cláusula Décima Primera del Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            “Intereses Ordinarios”. Tendrá el significado que se le atribuye en
            el primer párrafo de la Cláusula Décima Primera del Contrato.<br /><br />
          </span>

          <span class="ft9">
            “IVA de los Intereses Moratorios”. Significa el monto que resulte de
            multiplicar los Intereses Moratorios, por el porcentaje
            correspondiente del Impuesto al Valor Agregado, conforme a las
            disposiciones legales aplicables.
            <br /><br />
          </span>
          <span class="ft9">
            “IVA de los Intereses Ordinarios”. Significa el monto que resulte de
            multiplicar los Intereses Ordinarios, por el porcentaje
            correspondiente del Impuesto al Valor Agregado, conforme a las
            disposiciones legales aplicables. “Parcialidades”. Significan los
            montos de los pagos parciales del Importe Total del Crédito que el
            ACREDITADO deberá pagar al ACREDITANTE en cada Fecha de Pago de las
            Parcialidades, mismos que se indican en la Carátula junto con el
            número y periodicidad de dichos pagos parciales. En caso de que se
            genere algún otro accesorio, gasto o costa que deba ser pagado al
            ACREDITANTE conforme al Contrato, el monto de las Parcialidades
            podrá incrementar, de acuerdo con lo establecido en el Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            “Prenda”. Tendrá el significado que se le atribuye en el inciso (A)
            de la Cláusula Octava del Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            “Proveedor”. Significa la persona que se indica en el formato de pago a tercero
            que celebrará en esta fecha la compraventa del Bien con
            el ACREDITADO, y quien se encargará y será el único responsable de
            entregar a este último el Bien conforme a lo establecido en el
            Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            “Seguro”. Tendrá el significado que se le atribuye en la Cláusula
            Octava del Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            “Servicio de GPS. Tendrá el significado que se le atribuye en la
            Cláusula Octava del Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            Tasa de Interés Moratorio del Crédito”. Significa el porcentaje fijo
            que se indica en la Carátula, mismo que incluye el Impuesto al Valor
            Agregado.
            <br />
          </span>
          <span class="ft9">
            “Tasa de Interés Ordinario del Crédito”. Significa el porcentaje
            fijo que se indica en la Carátula, mismo que incluye el Impuesto al
            Valor Agregado, que resulte de multiplicar la tasa de interés
            mensual ordinaria que se indica en la Carátula, por el Plazo del
            Crédito que se indica en la Carátula.
            <br /><br />
          </span>
          <span class="ft9">
            “Tasa de Interés Ordinario del Crédito”. Significa el porcentaje
            fijo que se indica en la Carátula, mismo que incluye el Impuesto al
            Valor Agregado, que resulte de multiplicar la tasa de interés
            mensual ordinaria que se indica en la Carátula, por el Plazo del
            Crédito que se indica en la Carátula.
            <br /><br />
          </span>
          <span class="ft9">
            En virtud de los ANTECEDENTES, DECLARACIONES y DEFINICIONES
            anteriores, las PARTES otorgan y se sujetan a las siguientes:
            <br /><br />
          </span>
          <span class="ft9Black">
            <div class="col-12 text-center">CLÁUSULAS.<br /><br /></div>
          </span>
          <div class="text-justify">
            <span class="ft9">
              <span class="ft9Black">PRIMERA. INFORMACIÓN DEL CRÉDITO.</span> El
              ACREDITANTE explicó al ACREDITADO<span v-if="data.tipoObligado || data.tipoObligadoAval" class="ft9">y al
                “AVAL Y OBLIGADO SOLIDARIO"</span><span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">
                y el “AVAL Y OBLIGADO SOLIDARIO"</span>, la Información del Crédito y, por lo tanto, el contenido,
              alcance y efectos del Contrato, mismos que son de la comprensión
              del ACREDITADO<span v-if="data.tipoObligado || data.tipoObligadoAval" class="ft9"> y al “AVAL Y OBLIGADO
                SOLIDARIO"</span><span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">
                y el “AVAL Y OBLIGADO SOLIDARIO"</span>, Sin perjuicio de <br /><br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              3
            </span>
          </div>
        </footer>
      </div>
      <div id="page4-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br />lo anterior, el ACREDITANTE, podrá explicar al
            ACREDITADO y
            <span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">del “AVAL Y OBLIGADO SOLIDARIO" y</span>
            al OBLIGADO SOLIDARIO, de nueva cuenta y, en cualquier momento, la
            Información del Crédito, así como el contenido, alcance y efectos
            del Contrato.

            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black"> SEGUNDA. IMPORTE DEL CRÉDITO.</span> El
            objeto del Contrato consiste en que el ACREDITANTE otorgue al
            ACREDITADO el Crédito por la cantidad de
            <span v-bind:class="{ marca: data.showMarca }">
              ${{ data.monto_a_finaciar }},
            </span>
            mismo que se encuentra señalado en la Carátula y, el cual se hace
            del conocimiento al ACREDITADO. <br /><br />
          </span>
          <span class="ft9">
            En el Importe del Crédito, no se encuentran comprendidos intereses,
            Comisiones, impuestos, cargos, ni ningún otro accesorio o pago que,
            en su caso, el ACREDITANTE tenga derecho a recibir del ACREDITADO,
            en términos del Contrato.<br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black"> TERCERA. TASA DE INTERÉS ORDINARIA.</span>
            El Importe del crédito causará intereses a una tasa de interés del
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.tasa_ordinaria }}%
            </span>
            anual respecto al Importe del Crédito.<br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">CUARTA. DISPOSICIÓN DEL IMPORTE DEL CRÉDITO.</span>
            El ACREDITADO en este acto y mediante la firma del Contrato
            instruye, autoriza y faculta al ACREDITANTE, para que el Importe del
            Crédito sea depositado mediante cheque o transferencia electrónica a
            la cuenta: (i) del Proveedor para el pago del Bien, de conformidad
            con la Carta de Instrucción de Pago a Tercero; y, (ii) de la
            Aseguradora para el pago del Seguro, según sea el caso.

            <br /><br />
          </span>
          <span class="ft9">
            Como consecuencia de la disposición del Importe del Crédito que
            realice el ACREDITANTE a favor del ACREDITADO, el ACREDITADO estará
            obligado a pagar el Importe Total del Crédito, Intereses y
            accesorios al ACREDITANTE, mediante
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.plazo }}</span>
            Parcialidades y, en su caso, mediante otros pagos que se generen en
            términos del Contrato.<br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">
              QUINTA. PLAZO DEL CRÉDITO Y FORMA DE PAGO. </span>El plazo para restituir el Crédito y sus intereses será
            de
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.plazo }}</span>
            meses a partir del
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_primer_pago }}.
            </span>
            El monto del crédito, así como los intereses ordinarios y
            accesorios, deberán ser pagados mensualmente en
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.plazo }}
            </span>
            mensualidades fijas, cada una por la cantidad de
            <span v-bind:class="{ marca: data.showMarca }">
              ${{ data.mensualidad }} {{ data.mensualidad_letra }}
            </span>
            iniciando la primera el día
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_primer_pago }}
            </span>
            y la última el día
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_ultimo_pago }}. </span><br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">SEXTA. LUGAR DE PAGO.</span> El ACREDITADO
            realizará los pagos para restituir el Crédito e intereses en el
            domicilio del ACREDITANTE, o bien en la cuenta bancaria BANORTE CONVENIO CIE: 5524
            CUENTA: 0420253088 CLABE INTERBANCARIA 072320004202530888, con
            número de referencia
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.referencia_banco }}</span>
            a nombre del ACREDITANTE, o en alguna otra que el ACREDITANTE de a
            conocer al ACREDITADO.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">SEPTIMA. TASA MORATORIA.</span> En caso de
            que El Acreditado no cumpla en tiempo con alguno de sus pagos, estos
            generaran un interés moratorio a una tasa de
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.moratorio }}%</span>
            <!-- TODO: ponder dato en letas -->
            (<span v-bind:class="{ marca: data.showMarca }">
              {{ data.moratorio_letra }}</span>) mensual durante el tiempo que no sea cubierto.

            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">OCTAVA. GARANTÍA PRENDARIA.</span>
            (A)Garantía Prendaria descrita en el “FORMATO DE CARACTERÍSTICAS DEL
            BIEN”. El ACREDITADO, para garantizar el pago del Importe Total del
            Crédito y demás obligaciones a cargo del ACREDITADO conforme al
            Contrato, constituye a favor del ACREDITANTE una prenda sin
            transmisión de posesión sobre el Bien, descrito en la caratula de este contrato en primer lugar y grado de
            prelación (en adelante, la “Prenda”), en términos del Título II,
            Capítulo IV, Sección VII de la Ley General de Títulos y Operaciones
            de Crédito. Las PARTES acuerdan que la Prenda se constituye para
            garantizar a favor del ACREDITANTE el pago de: (i) el saldo insoluto
            de principal y accesorios del Crédito; (ii) cualquier otro importe
            que el ACREDITADO adeude al ACREDITANTE conforme al Contrato; y/o
            (iii) los gastos y costas que se causen por el procedimiento
            extrajudicial y/o judicial que, en su caso, sea instaurado por el
            ACREDITANTE en contra del ACREDITADO, para requerir el cumplimiento
            de las obligaciones que en términos del Contrato contrae a su cargo,
            para ejecutar la Prenda o el Pagaré.
            <br /><br />
          </span>
          <span class="ft9">
            (B) Endoso de la Factura del Bien. En virtud de la Prenda
            constituida sobre el Bien, dentro de los siguientes 3 días naturales
            a la fecha del Contrato, el ACREDITADO estará obligado a entregar al
            ACREDITANTE la factura original del Bien, debidamente endosada a su
            favor, y/o de igual manera, el ACREDITADO enviará al ACREDITANTE las
            versiones electrónicas de dicha factura en formato “xml” y “pdf”.
            <br /><br />
          </span>
          <span class="ft9">
            (C) Uso, Transmisión y Gravamen del Bien. El Bien única y
            exclusivamente podrá ser destinado por el ACREDITADO para uso
            particular o comercial (con excepción al uso de transporte público y
            de seguridad pública o privada). Asimismo, el ACREDITADO renuncia
            expresamente, mediante la firma del Contrato, a su derecho de: (i)
            enajenar, transmitir, transferir o de cualquier otra forma disponer
            del Bien, de conformidad con el artículo 356 y 374 de la Ley General
            de Títulos y Operaciones de Crédito; y, (ii) crear, transmitir,
            asumir o permitir la existencia de cualquier gravamen, prenda,
            garantía u otra carga o limitación a la propiedad sobre o en
            relación al Bien, distinta de la Prenda constituida en favor del
            ACREDITANTE de conformidad con el Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            (D) Conservación y Defensa del Bien. El ACREDITADO estará obligado a
            defender, a su costa, el Bien en contra de todas las acciones,
            juicios o procedimientos que inicie en su contra un tercero o ante
            cualquier autoridad gubernamental o tribunal. El ACREDITANTE tendrá
            el derecho (pero no la obligación) de defender el Bien, en el
            entendido que el ACREDITADO le reembolsará todos los costos o gastos
            documentados en los que incurra en relación con dicha defensa y los
            montos correspondientes serán parte del Importe Total del Crédito
            garantizado con la Prenda. En caso de que ocurra cualquier evento
            mencionado en el párrafo anterior, el ACREDITADO deberá notificar
            por escrito al ACREDITANTE respecto a dicha situación y explicar, en
            la notificación, todos los elementos relacionados con el
            procedimiento de que se trate, a efecto de que el ACREDITANTE pueda
            llevar a cabo las acciones que considere convenientes.

            <br /><br />
          </span>
          <span class="ft9">
            E) Vigencia de la Prenda. La Prenda permanecerá vigente hasta que
            sean cumplidas en su totalidad las obligaciones que en términos del
            Contrato contrae el ACREDITADO, incluyendo sin limitar el pago del
            Importe Total del Crédito. Dentro de los siguientes 30 Días Hábiles
            a que el ACREDITADO haya cumplido con todas sus obligaciones, el
            ACREDITANTE deberá liberar la Prenda para lo cual: (i) entregará al
            ACREDITADO un comprobante que acredite la liberación de la Prenda
            sobre el Bien; y, (ii) deberá tramitar la cancelación de dicha
            Prenda en los registros correspondientes y/o dar el aviso
            correspondiente a las autoridades competentes.
            <br /><br />
          </span>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              4
            </span>
          </div>
        </footer>
      </div>
      <div id="page5-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br />(F) Ejecución de la Prenda. En el supuesto de ejecución
            de la Prenda, se observará lo establecido en el artículo 246 de la
            Ley General de Títulos y Operaciones de Crédito; lo anterior, en el
            entendido de que el ACREDITADO podrá, en cualquier momento posterior
            a la firma del Contrato, manifestar su consentimiento para que el
            ACREDITANTE se haga dueño del Bien objeto de la Prenda.

            <br /><br />
          </span>
          <span class="ft9">
            Para efectos de la valuación del Bien, en caso de ejecución
            extrajudicial y/o judicial, las PARTES acuerdan que el valor del
            Bien será aquél que indique la “guía autométrica”, que se encuentre
            vigente durante el año de que se trate. En caso de que el valor del
            Bien indicado en dicha guía sea insuficiente para el cumplimiento de
            las obligaciones a cargo del ACREDITADO, incluyendo sin limitar para
            el pago de las cantidades mencionadas en el inciso (A), numerales
            (i), (ii) y/o (iii) de la presente Cláusula, el ACREDITADO pagará la
            diferencia al ACREDITANTE.
            <br /><br />
          </span>
          <span class="ft9">
            En todo caso, el ACREDITADO acepta expresamente que todos los
            equipos y/o sus accesorios adicionales que sean instalados al Bien,
            no serán tomados en cuenta para efectos de valuación del Bien y que
            los mismos no podrán ser desinstalados o removidos del Bien, si al
            hacerlo se causa demérito alguno a la integridad eléctrica, mecánica
            o estética del Bien.
            <br /><br />
          </span>
          <span class="ft9">
            (G) Posesión del Bien y Depositario. A partir de que el Proveedor
            haga entrega real del Bien al ACREDITADO, éste tendrá la posesión
            del mismo asumiendo las responsabilidades establecidas en el
            artículo 380 de la Ley General de Títulos y Operaciones de Crédito.
            Adicionalmente a lo anterior, a partir de la entrega virtual del
            Bien, en términos del inciso (B) de la Cláusula Sexta, las PARTES
            acuerdan que el ACREDITADO se constituirá como depositario del
            mismo, por lo que el ACREDITADO, mediante la firma del Contrato,
            acepta dicho carácter y asume plenamente todas las responsabilidades
            de cualquier naturaleza, incluyendo la civil y penal que pudiera
            derivarse (en adelante, el “Depositario”).<br /><br />
          </span>
          <span class="ft9">
            El depósito es a título gratuito y el Depositario, en la fecha en
            que le sea entregado virtualmente el Bien por parte del Proveedor se
            dará por recibido del mismo y comenzará a cumplir sus obligaciones
            derivadas del depósito y la Prenda a que se refiere la presente
            Cláusula. En este acto, el Depositario señala como domicilio, para
            la guarda y custodia del Bien, el indicado por el ACREDITADO en la
            Solicitud.

            <br /><br />
          </span>
          <span class="ft9">
            Para el caso de que el ACREDITANTE, por cualquier motivo, requiera
            la entrega material del Bien, el Depositario se obliga a entregarlo
            dentro de las 72 horas naturales siguientes al requerimiento que le
            haga el ACREDITANTE, en el domicilio que éste último le indique, a
            costa del ACREDITADO.
            <br /><br />
          </span>
          <span class="ft9">
            En adición a aquellas obligaciones que deba cumplir el Depositario,
            en términos de la legislación aplicable, el Depositario deberá: (i)
            conservar en su poder el Bien, debiendo realizar los actos
            necesarios para su debida conservación y mantenimiento; (ii) por
            ningún motivo y bajo ninguna circunstancia, enajenar, dar en
            garantía o afectar el uso o goce del Bien en forma alguna; (iii) por
            ningún motivo y bajo ninguna circunstancia, destinar el Bien a
            actividades que pudieren resultar riesgosas a la integridad física,
            eléctrica o mecánica del Bien, incluyendo sin limitar la prestación
            de servicios de transporte público o de seguridad pública o privada;
            (iv) verificar el debido funcionamiento y dar el mantenimiento
            necesario o conveniente al GPS instalado en el Bien con motivo del
            Servicio GPS, en el entendido de que en ningún caso y bajo ninguna
            circunstancia el ACREDITADO estará facultado para desinstalarlo del
            Bien; (v) verificar y realizar a su cargo y a su costa los pagos de
            tenencia, verificación y, en general, cualquier otra cantidad y/o
            impuesto y/o derecho relacionado al mantenimiento, uso y/o
            conservación del Bien, para que los mismos se encuentren debidamente
            realizados y al corriente; y, (vi) notificar inmediatamente al
            ACREDITADO de cualquier evento o situación que pudiera afectar el
            Bien o los derechos del ACREDITADO o del ACREDITANTE respecto del
            mismo.<br /><br />
          </span>
          <span class="ft9">
            (H) Durante la vigencia del Contrato, el ACREDITADO se obliga a
            contratar y mantener vigente, una póliza de seguro para el Bien con
            una cobertura que cubra como mínimo: robo total, pérdida total,
            responsabilidad civil en exceso y daños a terceros (en adelante, el
            “Seguro”), la cual deberá de mencionar un endoso preferente a favor
            de la persona que en su momento le indique el ACREDITANTE. El
            ACREDITADO, al momento de la firma del Contrato, en virtud de que,
            el ACREDITANTE le informó previamente dicho requisito para el
            otorgamiento del Crédito, deberá acreditar dicha contratación, pago
            y entregar evidencia de la misma, al momento de la celebración del
            Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            En caso de omisión por parte del ACREDITADO respecto a la
            contratación y entrega de la póliza de seguro, a que se hace mención
            en el párrafo anterior de la presente Cláusula, el ACREDITADO otorga
            su más amplio consentimiento y autoriza al ACREDITANTE mediante la
            Carta Instrucción de Pago a la Aseguradora para que, contrate a su
            nombre y representación el Seguro durante el periodo que sea
            acordado ya sea anual o multianual, con cargo al Importe del
            Crédito, por lo que el Importe Total del Crédito incrementará y se
            hará de su conocimiento mediante el respectivo estado de cuenta;
            cabe señalar, que para el caso en particular, el ACREDITANTE
            contratará el Seguro con la compañía que se describe en la Caratula,
            junto con sus características señaladas, condiciones generales,
            coberturas y procesos de reclamación en caso de algún siniestro, por
            lo que el pago que el ACREDITANTE realice será el descrito en la
            Carta Instrucción de Pago a la Aseguradora; así mismo, en la fecha
            de firma del Contrato se entregará al ACREDITADO copia simple de la
            póliza respectiva, teniendo 2 días naturales contados a partir de
            que le fue entregada la misma, para formular cualquier duda,
            aclaración o queja, que se relacione con está, en caso contrario, se
            darán por aceptados los términos y condiciones. Para el supuesto de
            que el ACREDITADO de por terminado de forma anticipada el Crédito y
            el ACREDITANTE ya haya realizado el pago y cargo del importe del
            Seguro respectivo, el ACREDITADO manifiesta su conformidad en que el
            Seguro esté vigente por el periodo que fue contratado, por lo que no
            procederá cancelación ni reembolso alguno a cargo del ACREDITANTE.

            <br /><br />
          </span>
          <span class="ft9">
            Para el caso, de que el periodo por el cual fue contratado el Seguro
            fuera anual, el ACREDITADO deberá de comunicarse con el ACREDITANTE,
            en un plazo no menor a 31 días naturales a la fecha en que se dé por
            vencido el Seguro, independientemente de que haya sido contratado
            por el ACREDITADO o por el ACREDITANTE en virtud del segundo párrafo
            de la presente Cláusula, para el efecto de que se le indique el
            procedimiento respecto de: i) poder renovar el Seguro que fue
            contratado por el ACREDITANTE; o, ii) poder acreditar la
            contratación, pago, así como entregar evidencia del Seguro al
            ACREDITANTE con la Aseguradora de su elección.<br /><br />
          </span>
          <span class="ft9">
            I) DAÑOS. Si el Bien sufre algún daño reparable y que, por cualquier
            causa, la Aseguradora no cubre íntegramente el costo de reparación,
            el ACREDITADO se obliga a realizar las reparaciones necesarias por
            su cuenta y costa, en un plazo no mayor a 30 días naturales
            posteriores a la fecha en que el daño fue causado al Bien. Por otro
            lado, y de conformidad con la Ley sobre el Contrato de Seguro, “en
            el caso de aquellos seguros de cosas
            <br /><br />
          </span>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              5
            </span>
          </div>
        </footer>
      </div>
      <div id="page6-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br />gravadas con prenda, los acreedores prendarios, se
            subrogarán de pleno derecho en la indemnización hasta el Importe del
            Crédito garantizado por tales gravámenes”, por lo que si el Bien
            sufriera un daño irreparable o pérdida total, las PARTES acuerdan
            que el ACREDITANTE estará facultado para recibir de la Aseguradora
            el monto correspondiente a la cobertura contratada y, si éste no
            alcanza para cubrir el Importe Total del Crédito, el ACREDITADO
            deberá pagar al ACREDITANTE el saldo pendiente de pago que le sea
            indicado.

            <br /><br />
          </span>
          <span class="ft9">
            El ACREDITADO se obliga a pagar a la Aseguradora cualquier cantidad
            correspondiente a deducible o coaseguro, así como hacer todas las
            gestiones y trámites que resulten necesarios para que la Aseguradora
            haga los pagos que correspondan por la actualización de los riegos,
            eventos o siniestros que cubra el Seguro.
            <br /><br />
          </span>
          <span class="ft9">
            J) BENEFICIARIOS DEL SEGURO. No obstante que el ACREDITADO será el
            asegurado, las PARTES acuerdan que, hasta en tanto las obligaciones
            a cargo del ACREDITADO no sean cumplidas en su totalidad, el
            beneficiario preferente será el ACREDITANTE. Una vez que el ACREDITANTE reciba los
            pagos que le correspondan en términos de la presente Cláusula y se
            le hubiere liberado de toda responsabilidad, se procederá a ceder al
            ACREDITADO todos los derechos que tuviera frente a la Aseguradora
            para que, a su vez, el ACREDITADO ejerza las acciones que a sus
            intereses convenga.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">NOVENA. PAGOS Y PAGARÉ.</span> El ACREDITADO
            estará obligado a pagar al ACREDITANTE las Parcialidades, así como
            cualquier otro pago que se genere en términos del Contrato, en la
            Fecha de Pago de las Parcialidades, mediante: (i) depósito o
            transferencia electrónica a la cuenta que se le indique en el
            Instrumento de Pago de las Parcialidades o, de cualquier otra forma
            que el ACREDITANTE le instruya por escrito, ya sea por medios
            electrónicos o mediante el estado de cuenta respectivo; y, (ii) bajo
            los términos que se establecen en el Instrumento de Pagos de las
            Parcialidades y del Contrato. Las PARTES pactan que, si la Fecha de
            Pago de las Parcialidades o cualquier otra fecha de pago no es Día
            Hábil, el pago correspondiente podrá realizarse el Día Hábil
            inmediato siguiente.<br /><br />
          </span>
          <span class="ft9">
            El ACREDITADO estará obligado a comprobar al ACREDITANTE, en
            cualquier momento, los pagos realizados en términos del Contrato,
            para lo cual deberá conservar las fichas de depósito o los recibos
            de depósito de los pagos realizados, toda vez que serán el único
            medio para demostrar al ACREDITANTE el cumplimiento de las
            obligaciones de pago a su cargo, en términos del Contrato.

            <br /><br />
          </span>
          <span class="ft9">
            El ACREDITADO en este acto suscribe, a su cargo y a favor del
            ACREDITANTE, un pagaré (en adelante, el “Pagaré”) cuyo importe
            asciende al Importe Total del Crédito y, el que, a su vez, documenta
            la disposición del Importe del Crédito, a que se refiere en la
            Cláusula Segunda de este contrato.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA. METODOLOGÍA DE CÁLCULO DE LOS INTERESES ORDINARIOS Y
              MORATORIOS.</span>
            El ACREDITADO se obliga a pagar al ACREDITANTE, intereses ordinarios
            sobre el Importe del Crédito, los cuales se calculan multiplicando
            la Tasa de Interés Ordinario del Crédito por el Importe del Crédito
            (en adelante, los “Interés Ordinarios”). Las PARTES reconocen que
            los Intereses Ordinarios no podrán ser exigidos por adelantado,
            únicamente por periodos vencidos.<br /><br />
          </span>
          <span class="ft9">
            En caso de que: (i) el ACREDITADO deje de pagar de forma completa
            y/o oportuna alguna cantidad que, en términos del Contrato, tenga la
            obligación de hacerlo; y, (ii) dicho incumplimiento continúe por más
            de un mes calendario; el ACREDITADO estará obligado a pagar
            intereses moratorios sobre el monto no pagado en forma oportuna y/o
            completa, hasta que éste se pague en su totalidad, los cuales se
            calculan multiplicando la Tasa de Interés Moratorio por el monto no
            pagado en forma oportuna y/o completa (en adelante, los “Intereses
            Moratorios”). Los Intereses Moratorios que, en su caso, se originen
            podrán ser pagados en la siguiente Fecha de Pago de las
            Parcialidades correspondiente, junto con los demás montos adeudados.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA PRIMERA. CARGO Y COMISIONES.</span>
            El ACREDITADO se obliga a pagar al ACREDITANTE los siguientes
            conceptos:

            <br /><br />
          </span>
          <span class="ft9">
            (A) Comisión por Apertura. El ACREDITADO se obliga a pagar una
            comisión equivalente al porcentaje indicado en la Carátula, más su
            respectivo impuesto al valor agregado, por el Importe del Crédito
            (en adelante, la "Comisión por Apertura"), la cual se generará por
            única ocasión al momento del otorgamiento del Crédito y se pagará en
            el domicilio del Proveedor con los recursos económicos que le sean
            propios, por lo cual no será parte del Crédito.<br /><br />
          </span>
          <span class="ft9">
            (B) Comisión por Gastos de Cobranza. En caso de que el ACREDITADO no
            realice el pago total de cualquier cantidad adeudada en la Fecha de
            Pago de las Parcialidades correspondiente, el ACREDITADO se obliga a
            pagar una comisión equivalente al porcentaje indicado en la
            Carátula, más su respectivo Impuesto al Valor Agregado, sobre el
            importe no pagado en forma oportuna y/o completa de la Parcialidad
            correspondiente (en adelante, la "Comisión por Gastos de Cobranza").
            Esta comisión se generará una sola vez por el hecho de que exista un
            incumplimiento de pago y deberá pagarse en una sola exhibición en la
            siguiente Fecha de Pago de las Parcialidades; lo anterior, en el
            entendido que si el mismo incumplimiento de pago continúa por más de
            un mes calendario, el ACREDITADO estará obligado a pagar Intereses
            Moratorios respecto a la cantidad no pagada en forma oportuna y/o
            completa a partir del Día Hábil siguiente a que termine el mes
            calendario correspondiente, de conformidad con lo establecido en el
            segundo párrafo de la Cláusula Décima Primera. Derivado de lo
            anterior, las PARTES reconocen que la Comisión por Gastos de
            Cobranza y los Intereses Moratorios se detonan por distintos
            supuestos de incumplimiento. (E) Comisión por Pago Anticipado. En
            caso de que el ACREDITADO realice un pago anticipado, en términos de
            la Cláusula Décima Novena y/o Vigésima, se obliga a pagar una
            comisión equivalente al porcentaje indicado en la Carátula, más su
            respectivo Impuesto al Valor Agregado, sobre el importe del pago
            anticipado (en adelante, la "Comisión por Pago Anticipado").

            <br /><br />
          </span>
          <span class="ft9">
            (C) Comisión por pago anticipado descrito en la caratula.
            <br /><br />
          </span>
          <span class="ft9">
            (D) Comisión por Gastos de Administración de Saldos descrito en la
            caratula.
            <br /><br />
          </span>
          <span class="ft9">
            (E) Comisión por Cargo de servicio GPS descrito en la caratula.
            <br /><br />
          </span>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              6
            </span>
          </div>
        </footer>
      </div>
      <div id="page7-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br /><span class="ft9Black">DÉCIMA SEGUNDA. APLICACIÓN Y ACREDITACIÓN DE PAGOS.</span>
            Cualquier pago que, en términos del Contrato, sea realizado por el
            ACREDITADO, será aplicado por el ACREDITANTE en el siguiente orden:
            (A) Al pago, en su caso, de los gastos y costas en los que incurra
            el ACREDITAN TE derivados de cualquier procedimiento extrajudicial
            y/o judicial que derive de un incumplimiento del ACREDITADO al
            Contrato, la ejecución del Pagaré o de la Prenda;

            <br /><br />
          </span>
          <span class="ft9">
            (B) Al pago, en su caso, del Impuesto al Valor Agregado de cualquier
            Comisión que el ACREDITADO adeude al ACREDITANTE por cualquier
            concepto derivado del Contrato;
            <br /><br />
          </span>
          <span class="ft9">
            (C) Al pago, en su caso, de cualquier comisión, que el ACREDITADO,
            en su caso, adeude al ACREDITANTE por cualquier concepto derivado
            del Contrato;
            <br />
          </span>
          <span class="ft9">
            (D) Al pago, en su caso, del Impuesto al Valor Agregado sobre los
            Intereses Moratorios;
            <br /><br />
          </span>
          <span class="ft9">
            (E) Al pago, en su caso, de los Intereses Moratorios, devengados
            hasta la fecha en que se efectúe el pago de que se trate;

            <br /><br />
          </span>
          <span class="ft9">
            (F) Al pago del Impuesto al Valor Agregado sobre los Intereses
            Ordinarios;
            <br /><br />
          </span>
          <span class="ft9">
            (G) Al pago de los Intereses Ordinarios devengados hasta la fecha en
            que se efectúe el pago de que se trate;<br /><br />
          </span>
          <span class="ft9">
            (H) El pago el remanente que resulte después de haber efectuado los
            pagos anteriores, se aplicará al pago de la suma principal insoluta
            del Crédito. El acreditamiento de los pagos será realizado por el
            ACREDITANTE dentro de los siguientes 5 Días Hábiles siguientes al
            que se haya recibido el pago correspondiente.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA TERCERA. EFECTOS DEL CUMPLIMIENTO DEL CONTRATO.</span>
            En caso de que el Importe Total del Crédito sea pagado, en los
            términos del Contrato, éste se dará por terminado y, por lo tanto,
            el ACREDITANTE procederá a la entrega a favor del ACREDITADO de: (i)
            el Pagaré; (ii) la factura del Bien (Si procede); (iii) la
            liberación de la Prenda conforme a la Cláusula Octava; y, (iv) en su
            caso, de los importes pagados en demasía por el ACREDITADO. Dicha
            entrega se llevará a cabo en el domicilio del ACREDITANTE, dentro de
            los 30 Días Hábiles siguientes al Día Hábil en que el ACREDITANTE
            reciba del ACREDITADO la solicitud de entrega correspondiente. Una
            vez realizada la entrega mencionada en la presente Cláusula, el
            ACREDITADO emitirá un acuse de recibo, mismo que se refutará como la
            recepción, a su entera satisfacción, de lo indicado en los numerales
            (i), (ii), (iii) y (iv) antes descritos.

            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA CUARTA. BURÓ DE CRÉDITO. El ACREDITADO
              <span v-if="data.tipoAval" class="ft9Black">
                y el “AVAL Y OBLIGADO SOLIDARIO"
              </span>
              <span class="ft9Black" v-else-if="data.tipoObligadoAval">
                y el AVAL y OBLIGADO SOLIDARIO
              </span>
              <span class="ft9Black" v-else>
                y el “AVAL Y OBLIGADO SOLIDARIO"
              </span>
            </span>
            autorizan al ACREDITANTE para que solicite y obtenga, de cualquier
            SOCIEDAD DE INFORMACIÓN CREDITICIA (en adelante, el “Buró de
            Crédito”), la información sobre su historial crediticio respecto de
            las operaciones crediticias y otras de naturaleza análoga que lo
            integran durante el tiempo que sea restituido El Crédito y sus
            intereses. Por lo tanto, y toda vez que el ACREDITADO
            <span v-if="data.tipoAval" class="ft9">
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              y el AVAL y OBLIGADO SOLIDARIO
            </span>
            <span class="ft9" v-else>
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            han leído y comprendido la naturaleza y alcance del Buró de Crédito
            y de la información contenida en su base de datos, cualquier
            incumplimiento del ACREDITADO
            <span v-if="data.tipoAval" class="ft9">
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              y el AVAL y OBLIGADO SOLIDARIO
            </span>
            <span class="ft9" v-else>
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            a las obligaciones de pago que a su cargo establecidas en el
            Contrato será registrado por el ACREDITANTE, en el Buró de Crédito
            con claves de observación establecidas en los reportes de crédito
            respectivos, las cuales podrán afectar el historial crediticio del
            ACREDITADO
            <span v-if="data.tipoAval" class="ft9">
              y el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              y el AVAL y OBLIGADO SOLIDARIO
            </span>
            <span class="ft9" v-else> y el “AVAL Y OBLIGADO SOLIDARIO"</span>.

            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA QUINTA. VIGENCIA.</span>
            La vigencia del Contrato iniciará a partir de su fecha de
            celebración y terminará en el día en que sean cumplimentadas, en su
            totalidad, las obligaciones que, en términos del Contrato, contrae
            el ACREDITADO a su cargo.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA SEXTA. DENUNCIA.</span>
            El ACREDITANTE podrá denunciar el Contrato en términos del artículo
            294 de la Ley General de Títulos y Operaciones de Crédito, avisando
            de ello al ACREDITADO con por lo menos 15 días naturales a la fecha
            en que se pretenda tenga efectos, sin que sea necesario el
            cumplimiento de formalidades especiales. El ACREDITADO acepta que
            dicho aviso podrá realizarse a través de correo electrónico a la
            dirección que se encuentra indicada en la Solicitud.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA SEPTIMA. PAGO ANTICIPADO.</span>
            Siempre que el ACREDITADO se encuentre al corriente en el
            cumplimiento de todas y cada una de sus obligaciones asumidas por la
            celebración del Contrato, podrá pagar anticipadamente al ACREDITANTE
            cualquier Parcialidad por vencer, debiendo: (i) notificárselo
            mediante escrito firmado, al correo electrónico
            atencionaclientes@gpiautocomercial.com.mx, o a través del domicilio
            establecido para tal efecto en las declaraciones, con al menos 31
            días naturales previos a su próxima Fecha de Corte; y, (ii) en todo
            caso pagar la Comisión por Pago Anticipado correspondiente.
            <br /><br />
          </span>
          <span class="ft9">
            El pago anticipado de cualquier Parcialidad causará la reducción del
            Plazo, en virtud de que se recorrerán la o las Fechas de Pago de las
            Parcialidades que no sean objeto del mismo, a efecto de que dichas
            Parcialidades sean pagadas por el ACREDITADO en forma consecutiva e
            ininterrumpida, generándose únicamente por dicho concepto el pago de
            la Comisión por Pago Anticipado; y, el excedente aplicándose a: (i)
            en su caso, el Seguro de conformidad con el segundo párrafo de la
            Cláusula Octava; y, (ii) la Comisión por Gastos de Administración de
            Saldo y al saldo insoluto por principal de la Parcialidad, por lo
            que se excluyen Intereses Ordinarios, el IVA de los Interese
            Ordinarios y el Cargo por Servicio de GPS de esa Parcialidad; y,
            (iii) deberá ser realizado mediante depósito o transferencia
            electrónica a la cuenta que se indique en el Instrumento de Pago de
            las Parcialidades o de cualquier otra forma que el ACREDITANTE le
            instruya por escrito, por medios electrónicos o mediante el estado
            de cuenta y bajo los términos que se establecen en el mismo.<br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">
              DÉCIMA OCTAVA. TERMINACIÓN ANTICIPADA.</span>
            El ACREDITADO podrá solicitar al ACREDITANTE, en cualquier tiempo,
            la terminación anticipada del Contrato, para lo cual el ACREDITADO
            deberá notificárselo al ACREDITANTE mediante escrito firmado, el
            correo electrónico atencionclientes@gpiautocomercial.com.mx, o a
            través del domicilio establecido para tal efecto en el tercer
            párrafo de la Cláusula Décima Sexta del Contrato, por lo que una vez
            presentada la solicitud de terminación anticipada, el ACREDITANTE a
            más tardar el Día Hábil siguiente al de la recepción de dicha
            solicitud, deberá: (i) dar por terminado el Contrato, si es que no
            existen obligaciones de pago pendientes de conformidad con el
            Contrato; o, (ii) comunicar al ACREDITADO el importe a que ascienden
            los adeudos a cargo de éste, cabe señalar que se excluirán por dicho
            concepto el pago de Intereses Ordinarios, IVA de los Interés
            Ordinarios y el Cargo por Servicio de GPS, así mismo el ACREDITANTE

            <br /><br />
          </span>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              7
            </span>
          </div>
        </footer>
      </div>
      <div id="page8-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br />pondrá a su disposición dicho dato dentro de los 10 Días
            Hábiles siguientes al de la solicitud de terminación anticipada, en
            el domicilio o medio elegido por el ACREDITADO, por lo que, una vez
            que el ACREDITADO realice el pago total de sus obligaciones de pago,
            de acuerdo a las condiciones que al efecto establezca el
            ACREDITANTE, se dará por terminado anticipadamente el Contrato; sin
            embargo, si dentro del plazo establecido con anterioridad, el
            ACREDITADO no realiza el pago, el Contrato continuará vigente bajo
            sus mismos términos.

            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">DÉCIMA NOVENA. VENCIMIENTO ANTICIPADO DEL CONTRATO.</span>
            En caso que ocurra cualquiera de los eventos de incumplimiento que
            se mencionan a continuación, el ACREDITANTE podrá dar por vencido
            anticipadamente el Contrato y, por lo tanto, el ACREDITADO
            <span v-if="data.tipoAval" class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              y/o el AVAL y/o el OBLIGADO SOLIDARIO
            </span>
            <span class="ft9" v-else>
              y/o el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            deberá pagar a favor del ACREDITANTE: i) el saldo insoluto por
            principal, así como por accesorios del Crédito; y, ii) cualquier
            otro importe que el ACREDITADO adeude al ACREDITANTE conforme al
            Contrato, dentro de los siguientes 3 Días Hábiles siguientes a la
            fecha en que el ACREDITANTE le haya notificado la existencia de
            cualquiera de dichos eventos de incumplimiento:
            <br />
            a) El Crédito no sea pagado en los términos del Contrato. <br />
          </span>
          <span class="ft9">
            b) La falta de pago, por cualquier motivo, de alguna de las
            Parcialidades en las Fechas de Pago de las Parcialidades.

            <br />
          </span>
          <span class="ft9">
            c) La falsedad o inexactitud en cualquiera de las DECLARACIONES,
            información o documentación realizada o entregada por el ACREDITADO
            <span v-if="data.tipoAval" class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"
            </span>
            <span class="ft9" v-else-if="data.tipoObligadoAval">
              y/o el AVAL y/o el OBLIGADO SOLIDARIO
            </span>
            <span class="ft9" v-else> y/o el OBLIGADO SOLIDARIO</span>.
            <br /><br />
          </span>
          <span class="ft9">
            d) El incumplimiento del ACREDITADO
            <span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"</span>
            <span v-if="data.tipoObligado || data.tipoObligadoAval" class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"</span>
            a cualquier obligación que, en términos del Contrato, se encuentra
            establecida a su cargo.
            <br /><br />
          </span>
          <span class="ft9">
            e) El estado de insolvencia del ACREDITADO
            <span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"</span><span v-if="data.tipoObligado || data.tipoObligadoAval"
              class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"</span>. <br /><br />
          </span>
          <span class="ft9">
            f) La pérdida, destrucción, deterioro, pérdida de propiedad, pérdida
            de posesión de la Garantía Prendaria, por cualquier motivo,
            incluyendo siniestro, accidente, caso fortuito o fuerza mayor; en el
            entendido que en cualquiera de dichos casos el ACREDITADO, expresa e
            irrevocablemente renuncia en este acto a todo derecho que tenga o
            pueda llegar a tener a la reducción, prórroga del plazo para el
            cumplimiento o liberación de las obligaciones a su cargo, de
            conformidad con el Contrato.<br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA. CASO FORTUITO O FUERZA MAYOR.</span>
            El ACREDITADO se obliga ante el ACREDITANTE al debido cumplimiento
            de las obligaciones que a su cargo se encuentran en el Contrato,
            incluso en presencia de hechos o eventos de caso fortuito y/o de
            fuerza mayor. <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA PRIMERA. IMPUESTOS.</span>
            Todos los impuestos, contribuciones y derechos que deban cubrirse
            con motivo de la celebración y ejecución del Contrato, serán
            cubiertos por la parte que resulte obligada a ello, de conformidad
            con las disposiciones fiscales aplicables.

            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA SEGUNDA. TRANSMISIÓN.</span>
            Salvo por lo mencionado en el párrafo siguiente, las PARTES no
            podrán transmitir cualquier derecho u obligación que, en términos
            del Contrato, resulte a su favor o a su cargo, sin la previa
            aprobación por escrito de la contraparte, por lo que cualquier
            transmisión en términos distintos a los aquí previstos será nula y
            no será reconocida por la parte de que se trate. En virtud de lo
            anterior, el ACREDITADO<span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">
              y el “AVAL Y OBLIGADO SOLIDARIO"</span>
            <span v-if="data.tipoObligado || data.tipoObligadoAval" class="ft9">
              y el OBLIGADO SOLIDARIO</span>: (i) autorizan expresamente al ACREDITANTE para que en cualquier
            momento pueda, sin autorización del ACREDITADO<span v-if="data.tipoAval || data.tipoObligadoAval"
              class="ft9">
              y el “AVAL Y OBLIGADO SOLIDARIO"</span>
            <span v-if="data.tipoObligado || data.tipoObligadoAval" class="ft9">
              y el OBLIGADO SOLIDARIO</span>, endosar, ceder, transmitir, descontar, transferir, negociar,
            afectar y/o gravar, total o parcialmente, cualquier derecho que, en
            términos del Contrato, resulte a favor del ACREDITANTE, incluyendo
            sin limitar los derechos de crédito contenidos en el Contrato, en el
            Pagaré y/o aquellos relacionados con la Prenda; y, (ii) renuncia
            expresamente a lo establecido en el segundo párrafo del artículo 299
            de la Ley General de Títulos y Operaciones de Crédito. Lo
            establecido en el presente párrafo, aplicará, de igual forma,
            respecto a cualquier acreedor y/o causahabiente subsecuente.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA TERCERA. MODIFICACIÓN.</span>
            Para cualquier modificación relacionada con el Contrato, el
            ACREDITANTE dará aviso al ACREDITADO, con 30 días naturales de
            anticipación al día en que entre en vigor la modificación de que se
            trate, a través del estado de cuenta respectivo. En caso de que el
            ACREDITADO no esté de acuerdo con la modificación propuesta por el
            ACREDITANTE, el ACREDITADO podrá solicitar la terminación del
            Contrato dentro de los 60 días naturales posteriores a dicho aviso,
            sin responsabilidad alguna a su cargo, debiendo pagar el saldo
            insoluto del Importe Total del Crédito y/o cualquier otro importe
            que adeude al ACREDITANTE conforme al Contrato. Para tal efecto, el
            ACREDITADO deberá presentar la solicitud de terminación por escrito
            firmado ante el ACREDITANTE, al domicilio establecido en las
            declaraciones del Contrato, quien informará al ACREDITADO, el mismo
            Día Hábil al de su recepción, el saldo insoluto a pagar. El
            ACREDITADO deberá realizar dicho pago dentro del plazo de los 30
            días naturales posteriores de referencia; si dentro de dicho plazo
            el ACREDITADO no realiza el pago, el Contrato continuará vigente y
            se entenderá que el ACREDITADO aceptó tácitamente las modificaciones
            al Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA CUARTA. LEYES APLICABLES. </span>
            El Contrato se rige por lo dispuesto en sus Cláusulas y, en su
            defecto o supletoriamente, por las disposiciones contenidas y que
            resulten aplicables de la Ley General de Títulos y Operaciones de
            Crédito, de la Ley Federal de Protección al Consumidor, de la Ley
            para la Transparencia y Ordenamiento de los Servicios Financieros,
            de la Disposiciones de Carácter General en materia de Contratos de
            Adhesión Emitidas por la Procuraduría Federal del Consumidor
            aplicables a las Entidades Comerciales, del Código de Comercio, así
            como del Código Civil Federal.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA QUINTA. DOMICILIOS.</span>
            Las PARTES señalan como sus domicilios, para efectos de
            notificaciones de carácter extrajudicial o judicial que se
            relacionen con el Contrato, los descritos en las DECLARACIONES del
            Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            Sin embargo, las PARTES podrán cambiar o señalar en el futuro
            cualquier otro domicilio, mediante notificación realizada a la otra
            parte con por lo menos 10 Días Hábiles de anticipación, en el
            entendido que, de no proporcionarse tal aviso de cambio, todas y
            cada una de las notificaciones que se le hicieren a la parte de que
            se trate, en el domicilio que ahora señala, se considerarán
            legalmente realizadas en su perjuicio.<br /><br />
          </span>
          <span class="ft9">
            Las notificaciones extrajudiciales que tengan que realizar las
            PARTES, serán por escrito, dirigidas a la contraparte, mediante
            entrega personal con acuse de recibo en el respectivo domicilio y
            serán entregadas en la fecha en que sean recibidas por la parte a
            quien hayan sido dirigidas.
            <br /><br />
          </span>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              8
            </span>
          </div>
        </footer>
      </div>
      <div id="page9-div" class="container interline border page-container p-4">
        <div class="col-12 text-justify content-wrap">
          <span class="ft9">
            <br /><br />Sin perjuicio de lo establecido en los párrafos primero
            y tercero de la presente Cláusula, las notificaciones
            extrajudiciales que sean relativas al requerimiento del o de los
            pagos del Crédito al ACREDITADO<span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"</span><span v-if="data.tipoObligado || data.tipoObligadoAval"
              class="ft9">
              y/o el “AVAL Y OBLIGADO SOLIDARIO"</span>, podrán realizarse por el ACREDITANTE, en cualquier domicilio
            del
            ACREDITADO<span v-if="data.tipoAval || data.tipoObligadoAval" class="ft9">
              y/o el AVAL</span>
            <span v-if="data.tipoObligado || data.tipoObligadoAval" class="ft9">
              y/o el OBLIGADO SOLIDARIO</span>
            que sea del conocimiento del ACREDITANTE, por escrito y, entregadas
            en forma personal, sin acuse de recibo.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA SEXTA. SUBTÍTULOS.</span>
            Los subtítulos en las Cláusulas del Contrato son exclusivamente por
            conveniencia de las PARTES, para una referencia y lectura más
            simple, por lo que no regirán la interpretación del Contrato.
            <br /><br />
          </span>
          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA SEPTIMA. COMPETENCIA. </span>
            La PROCURADURÍA FEDERAL DEL CONSUMIDOR será competente en la vía
            administrativa para resolver cualquier controversia que se suscite
            sobre la interpretación o cumplimiento del Contrato. Sin perjuicio
            de lo anterior, las PARTES, para la interpretación y/o cumplimiento
            del Contrato, se someten de manera expresa a la jurisdicción de los
            Tribunales competentes ya sea a los domicilios indicados en la
            clausula VIGÉSIMA QUINTA o la ciudad de Guadalajara, Jalisco, o a
            los tribunales de la Cuidad de México, renunciando expresamente a
            cualquier otro fuero que pudiera corresponderles de acuerdo a sus
            domicilios futuros o por cualquier otra causa.
            <br /><br />
          </span>

          <span class="ft9">
            <span class="ft9Black">VIGÉSIMA OCTAVA.- "CONFORMIDAD CON EL CONTRATO".</span>
            Las partes comparecientes expresan que el presente Contrato lo
            celebran con su libre y espontánea voluntad, que en el mismo no
            existe error, dolo, mala fe, violencia física ni moral, ni el
            concepto de enriquecimiento ilegítimo en favor o en contra del
            alguna de las partes contratantes, por lo que desde este momento
            renuncian a los beneficios que por dichos conceptos le otorga la
            Ley, de acuerdo a los artículos relativos del Código Civil Federal y
            sus correlativos para los estados de la República Mexicana.
            <br /><br />
          </span>
          <span class="ft9">
            De conformidad con lo pactado en el presente Contrato, y enteradas
            de su contenido y alcance legal, “LAS PARTES” lo suscriben en la
            Ciudad de Guadalajara Jalisco, el
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}.
            </span>
            <br /><br /><br /><br />
          </span>
          <div class="col-15 row">
            <div class="col-3 text-center"></div>
            <div class="col-6 border-bottom border-dark text-center pt-xl-5">
              <span class="ft11"> EL ACREDITADO<br /><br /><br /><br /> </span>
            </div>
          </div>
          <div class="col-15 row">
            <div class="col-3 text-center"></div>
            <div class="col-6 text-center pt-3 ">
              <span class="ft11">
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.nombre_cliente }}
                </span>
              </span>
              <br /><br /><br /><br />
            </div>
          </div>
          <div v-if="data.tipoAval || data.tipoObligadoAval" class="col-12 row">
            <div class="col-3 text-center"></div>
            <div class="col-6 border-bottom border-dark text-center pt-3">
              <span class="ft11"> AVAL Y OBLIGADO SOLIDARIO<br /><br /><br /><br /> </span>
            </div>
          </div>
          <div v-if="data.tipoAval || data.tipoObligadoAval" class="col-12 row">
            <div class="col-3 text-center"></div>
            <div class="col-6 text-center pt-3 ">
              <span class="ft11">
                <span v-bind:class="{ 'marca-aval': data.showMarca }">
                  {{ data.nombre_aval }}</span>
              </span>
            </div>
          </div>
          <div v-if="data.tipoObligado || data.tipoObligadoAval" class="col-12 row">
            <div class="col-3 text-center"></div>
            <div class="col-6 border-bottom border-dark text-center pt-3">
              <span class="ft11">
                AVAL Y OBLIGADO SOLIDARIO<br /><br /><br /><br />
              </span>
            </div>
          </div>
          <div v-if="data.tipoObligado || data.tipoObligadoAval" class="col-12 row">
            <div class="col-3 text-center"></div>
            <div class="col-6 text-center pt-3 ">
              <span class="ft11">
                <span v-bind:class="{ 'marca-obligado': data.showMarca }">
                  {{ data.nombre_obligado }}</span>
              </span>
            </div>
          </div>
          <div class="col-15 row ">
            <div class="col-3 text-center"></div>
            <div class="col-6 border-bottom border-dark text-center pt-lg-5">
              <span class="ft11 ">
                EL ACREDITANTE<br /><br />
                <span class="ft11Black pt-lg-5">GPI AUTO COMERCIAL SAPI DE C.V.<br /><br />
                  <br /><br />
                </span>
              </span>
            </div>
          </div>
          <div class="col-15 row">
            <div class="col-3 text-center"></div>
            <div class="col-6 text-center pt-md-4 ">
              <span class="ft11">
                Representada por; JESÚS FERNÁNDEZ MORÁN<br /><br />
              </span>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft9Black text-center">
              9
            </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "ContatoPrenda",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/Caratura1/contratoconprenda.vue